import { useQuery } from '@tanstack/react-query';
import coSellClient from 'packages/cosell/api/coSellClient';

/**
 * a query to fetch & cache the vendor previewV3Enabled setting
 */
export function usePreviewV3EnabledQuery({ vendorId }: { vendorId: string }) {
  return useQuery({
    queryKey: ['getAcePreviewV3Enabled', vendorId],
    queryFn: coSellClient.getSettings,
    select: (data) => {
      return data.previewV3Enabled;
    },
    staleTime: Infinity,
  });
}
